import { render, staticRenderFns } from "./MyCollection.vue?vue&type=template&id=ceeeb894&scoped=true&"
import script from "./MyCollection.vue?vue&type=script&lang=js&"
export * from "./MyCollection.vue?vue&type=script&lang=js&"
import style0 from "./MyCollection.vue?vue&type=style&index=0&id=ceeeb894&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceeeb894",
  null
  
)

export default component.exports